import React, { Fragment } from 'react';
import { ButtonBase } from '@material-ui/core';
import { CommonButton } from '../Reusable/Buttons/Buttons';
import { CommonButtonTypes } from 'Common/Types/Types';
import { useStyles } from './membership.style';
import { useHistory } from 'react-router-dom';
import { Routes } from 'Utils/Route';

interface MenuProps extends CommonButtonTypes {
	width?: string;
	url?: string;
	type?: string;
	image?: string;
	description?: string;
	timeline?: string;
	link?: string | undefined;
	total?: string | undefined;
	info?: string | undefined;
	id?: string | undefined;
}
const MembershipCards = ({ width, type, description, image, info, total, link, timeline,id }: MenuProps) => {
	const classes = useStyles();
	const history = useHistory();
	const [open, setOpen] = React.useState(false);
	const handleClick = (link: any, id: any) => {
		history.push(link + `/${id}`);
	};
	return (
		<Fragment>
			<div className={classes.root}>
				<ButtonBase
					className={classes.image}
					style={{
						width: width,
					}}
				>
					<span
						className={classes.imageSrc}
						style={{
							backgroundImage: `url(${image})`,
						}}
					/>
					<div className="d-flex flex-column justify-content-between w-100 align-items-center mx-4 my-2">
						<h3 className={classes.type}>{type}</h3>
						<p className={classes.description}>{description}</p>
						<p style={{ marginTop:'1rem' }}>
							<span>{total}</span>
							{timeline}
						</p>
					</div>
				</ButtonBase>
				<CommonButton
					onClick={() => handleClick(link, id)}
					common={{
						width: '181.87px',
						height: '48px',
						background: '#7FD6DD',
						radius: '200px',
					}}
					command={info}
				/>
			</div>
		</Fragment>
	);
};

export default MembershipCards;
